import React from "react";
import styles from './index.module.css';
import {Flex, Text, useTheme} from "@aws-amplify/ui-react";

const Footer = () => {
  const {tokens} = useTheme();

  const year = new Date().getFullYear();

  return (
    <Flex
      textAlign="center"
      justifyContent="center"
      alignItems="center"
      backgroundColor={tokens.colors.brand.primary[100]}
      padding={tokens.space.large}
      className={styles.footerWrapper}
    >
      <Text color={tokens.colors.font.secondary}>
        <a href="https://myedu.it/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>&nbsp;|&nbsp;
        <a href="/cookie-policy" target="_blank" rel="noreferrer">Cookie Policy</a>&nbsp;|&nbsp;
        <a href="/assistenza" target="_blank" rel="noreferrer">Assistenza</a><br/>
        Copyright {year} FME Education S.p.A - P.I. 08233380966
      </Text>
    </Flex>
  );
}

export default Footer;